import type { MonthlyClubReport } from '../types/monthlyClubReport';

// Static mock reports. Members at month end = previous month end + sign-ups - cancellations,
// and revenue totals = sign-up revenue + renewal revenue.
export const monthlyClubReports: MonthlyClubReport[] = [{
  id: '2026-09',
  monthLabel: 'September 2026',
  periodLabel: '1 to 30 September 2026',
  generatedAt: '1 Oct 2026, 7:00 AM',
  prevMonthLabel: 'August 2026',
  prevShort: 'Aug',
  yearAgoLabel: 'September 2025',
  yearAgoShort: 'Sep 2025',
  prevColumn: 'Aug 2026',
  headline: {
    members: {
      value: 1248,
      prev: 1231,
      yearAgo: 1102
    },
    signups: {
      value: 41,
      prev: 35,
      yearAgo: 30
    },
    cancellations: {
      value: 24,
      prev: 28,
      yearAgo: 21
    },
    revenue: {
      value: 96150,
      prev: 99870,
      yearAgo: 82130
    }
  },
  signupChannels: [{
    label: 'Online (storefront)',
    thisMonth: 22,
    prev: 19,
    yearAgo: 18
  }, {
    label: 'Cellar door (point of sale)',
    thisMonth: 12,
    prev: 10,
    yearAgo: 8
  }, {
    label: 'Created in WinePik by staff',
    thisMonth: 7,
    prev: 6,
    yearAgo: 4
  }],
  revenue: {
    signup: {
      value: 9840,
      prev: 8420,
      yearAgo: 7150
    },
    renewal: {
      value: 86310,
      prev: 91450,
      yearAgo: 74980
    }
  },
  forecast: {
    asAt: '30 Sep 2026',
    revenue: 1184600,
    orders: 4720
  },
  health: [{
    label: 'Net member growth rate (12 months)',
    how: '(402 sign-ups in the last 12 months minus 256 cancellations) divided by 1,102 active members on 30 Sep 2025',
    format: 'percent',
    value: 13.2,
    prev: 12.6,
    yearAgo: 9.8
  }, {
    label: 'Average order value (12 months)',
    how: '$1,092,400 club revenue divided by 4,512 club orders in the last 12 months',
    format: 'currencyCents',
    value: 242.11,
    prev: 240.37,
    yearAgo: 236.9
  }, {
    label: 'Average value per member',
    how: '$1,184,600 forecast revenue divided by 1,248 active members',
    format: 'currencyCents',
    value: 949.2,
    prev: 951.05,
    yearAgo: 912.4
  }],
  clubs: [{
    name: 'Estate Club',
    members: 612,
    changeVsPrev: 9,
    packs: [{
      label: '6 bottles every 3 months',
      members: 348,
      changeVsPrev: 5
    }, {
      label: '6 bottles every 6 months',
      members: 264,
      changeVsPrev: 4
    }]
  }, {
    name: 'Reserve Club',
    members: 418,
    changeVsPrev: 6,
    packs: [{
      label: '12 bottles every 3 months',
      members: 251,
      changeVsPrev: 4
    }, {
      label: '12 bottles every 6 months',
      members: 167,
      changeVsPrev: 2
    }]
  }, {
    name: 'Museum Release Club',
    members: 218,
    changeVsPrev: 2,
    packs: [{
      label: '6 bottles, 2 release dates a year',
      members: 218,
      changeVsPrev: 2
    }]
  }],
  singleClubPacks: [{
    label: '6 bottles every 3 months',
    members: 486,
    changeVsPrev: 8
  }, {
    label: '6 bottles every 6 months',
    members: 312,
    changeVsPrev: 4
  }, {
    label: '12 bottles every 3 months',
    members: 274,
    changeVsPrev: 3
  }, {
    label: '12 bottles every 6 months',
    members: 176,
    changeVsPrev: 2
  }]
}, {
  id: '2026-08',
  monthLabel: 'August 2026',
  periodLabel: '1 to 31 August 2026',
  generatedAt: '1 Sep 2026, 7:00 AM',
  prevMonthLabel: 'July 2026',
  prevShort: 'Jul',
  yearAgoLabel: 'August 2025',
  yearAgoShort: 'Aug 2025',
  prevColumn: 'Jul 2026',
  headline: {
    members: {
      value: 1231,
      prev: 1224,
      yearAgo: 1093
    },
    signups: {
      value: 35,
      prev: 38,
      yearAgo: 29
    },
    cancellations: {
      value: 28,
      prev: 26,
      yearAgo: 22
    },
    revenue: {
      value: 99870,
      prev: 94440,
      yearAgo: 86630
    }
  },
  signupChannels: [{
    label: 'Online (storefront)',
    thisMonth: 19,
    prev: 21,
    yearAgo: 17
  }, {
    label: 'Cellar door (point of sale)',
    thisMonth: 10,
    prev: 11,
    yearAgo: 8
  }, {
    label: 'Created in WinePik by staff',
    thisMonth: 6,
    prev: 6,
    yearAgo: 4
  }],
  revenue: {
    signup: {
      value: 8420,
      prev: 9010,
      yearAgo: 6980
    },
    renewal: {
      value: 91450,
      prev: 85430,
      yearAgo: 79650
    }
  },
  forecast: {
    asAt: '31 Aug 2026',
    revenue: 1170740,
    orders: 4660
  },
  health: [{
    label: 'Net member growth rate (12 months)',
    how: '(397 sign-ups in the last 12 months minus 259 cancellations) divided by 1,093 active members on 31 Aug 2025',
    format: 'percent',
    value: 12.6,
    prev: 12.7,
    yearAgo: 9.4
  }, {
    label: 'Average order value (12 months)',
    how: '$1,078,780 club revenue divided by 4,488 club orders in the last 12 months',
    format: 'currencyCents',
    value: 240.37,
    prev: 239.2,
    yearAgo: 235.6
  }, {
    label: 'Average value per member',
    how: '$1,170,740 forecast revenue divided by 1,231 active members',
    format: 'currencyCents',
    value: 951.05,
    prev: 946.32,
    yearAgo: 905.1
  }],
  clubs: [{
    name: 'Estate Club',
    members: 603,
    changeVsPrev: 4,
    packs: [{
      label: '6 bottles every 3 months',
      members: 343,
      changeVsPrev: 3
    }, {
      label: '6 bottles every 6 months',
      members: 260,
      changeVsPrev: 1
    }]
  }, {
    name: 'Reserve Club',
    members: 412,
    changeVsPrev: 2,
    packs: [{
      label: '12 bottles every 3 months',
      members: 247,
      changeVsPrev: 1
    }, {
      label: '12 bottles every 6 months',
      members: 165,
      changeVsPrev: 1
    }]
  }, {
    name: 'Museum Release Club',
    members: 216,
    changeVsPrev: 1,
    packs: [{
      label: '6 bottles, 2 release dates a year',
      members: 216,
      changeVsPrev: 1
    }]
  }],
  singleClubPacks: [{
    label: '6 bottles every 3 months',
    members: 478,
    changeVsPrev: 3
  }, {
    label: '6 bottles every 6 months',
    members: 308,
    changeVsPrev: 2
  }, {
    label: '12 bottles every 3 months',
    members: 271,
    changeVsPrev: 1
  }, {
    label: '12 bottles every 6 months',
    members: 174,
    changeVsPrev: 1
  }]
}, {
  id: '2026-07',
  monthLabel: 'July 2026',
  periodLabel: '1 to 31 July 2026',
  generatedAt: '1 Aug 2026, 7:00 AM',
  prevMonthLabel: 'June 2026',
  prevShort: 'Jun',
  yearAgoLabel: 'July 2025',
  yearAgoShort: 'Jul 2025',
  prevColumn: 'Jun 2026',
  headline: {
    members: {
      value: 1224,
      prev: 1212,
      yearAgo: 1086
    },
    signups: {
      value: 38,
      prev: 33,
      yearAgo: 27
    },
    cancellations: {
      value: 26,
      prev: 21,
      yearAgo: 20
    },
    revenue: {
      value: 94440,
      prev: 88130,
      yearAgo: 80760
    }
  },
  signupChannels: [{
    label: 'Online (storefront)',
    thisMonth: 21,
    prev: 18,
    yearAgo: 16
  }, {
    label: 'Cellar door (point of sale)',
    thisMonth: 11,
    prev: 10,
    yearAgo: 7
  }, {
    label: 'Created in WinePik by staff',
    thisMonth: 6,
    prev: 5,
    yearAgo: 4
  }],
  revenue: {
    signup: {
      value: 9010,
      prev: 7920,
      yearAgo: 6640
    },
    renewal: {
      value: 85430,
      prev: 80210,
      yearAgo: 74120
    }
  },
  forecast: {
    asAt: '31 Jul 2026',
    revenue: 1158300,
    orders: 4610
  },
  health: [{
    label: 'Net member growth rate (12 months)',
    how: '(391 sign-ups in the last 12 months minus 253 cancellations) divided by 1,086 active members on 31 Jul 2025',
    format: 'percent',
    value: 12.7,
    prev: 12.4,
    yearAgo: 9.1
  }, {
    label: 'Average order value (12 months)',
    how: '$1,069,224 club revenue divided by 4,470 club orders in the last 12 months',
    format: 'currencyCents',
    value: 239.2,
    prev: 238.45,
    yearAgo: 234.8
  }, {
    label: 'Average value per member',
    how: '$1,158,300 forecast revenue divided by 1,224 active members',
    format: 'currencyCents',
    value: 946.32,
    prev: 941.7,
    yearAgo: 899.8
  }],
  clubs: [{
    name: 'Estate Club',
    members: 599,
    changeVsPrev: 6,
    packs: [{
      label: '6 bottles every 3 months',
      members: 340,
      changeVsPrev: 4
    }, {
      label: '6 bottles every 6 months',
      members: 259,
      changeVsPrev: 2
    }]
  }, {
    name: 'Reserve Club',
    members: 410,
    changeVsPrev: 4,
    packs: [{
      label: '12 bottles every 3 months',
      members: 246,
      changeVsPrev: 3
    }, {
      label: '12 bottles every 6 months',
      members: 164,
      changeVsPrev: 1
    }]
  }, {
    name: 'Museum Release Club',
    members: 215,
    changeVsPrev: 2,
    packs: [{
      label: '6 bottles, 2 release dates a year',
      members: 215,
      changeVsPrev: 2
    }]
  }],
  singleClubPacks: [{
    label: '6 bottles every 3 months',
    members: 475,
    changeVsPrev: 5
  }, {
    label: '6 bottles every 6 months',
    members: 306,
    changeVsPrev: 3
  }, {
    label: '12 bottles every 3 months',
    members: 270,
    changeVsPrev: 3
  }, {
    label: '12 bottles every 6 months',
    members: 173,
    changeVsPrev: 1
  }]
}];
